import { useState } from 'react';
import http from 'common/http';
import styled from 'styled-components';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { Link, useLocation } from 'react-router-dom';

const Page = styled.div`
  height: 100vh;
`;

const Header = styled.header`
  border-bottom: rgba(255, 255, 255, 0.2) 1px solid;
  background: url(${require('assets/images/custom_top_pic.png').default}) no-repeat;
  background-size: 5.46rem 5.28rem;
  background-position: 98% 50%;
  background-origin: padding-box;
  background-color: #006edd;
  height: 6.25rem;

  padding: 0 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  h3 {
    color: white;
    margin-bottom: 1rem;
    font-size: 1.13rem;
  }

  p {
    color: white;
    font-size: 0.94rem;
  }
`;

const MTabList = styled(TabList)`
  background-color: #006edd;
  margin: 0;
  display: flex;
  list-style: none;
  padding: 0 1rem;
`;
const MTab = styled(Tab)`
  font-size: 0.88rem;
  color: white;
  line-height: 1;
  margin-right: 1rem;
  position: relative;
  height: 3.12rem;
  display: flex;
  align-items: center;
  &.react-tabs__tab--selected {
    font-size: 0.94rem;
    font-weight: bold;

    &::after {
      display: block;
    }
  }
  &::after {
    position: absolute;
    top: 75%;
    left: 50%;
    transform: translate3d(-50%, 0, 0);
    content: '';
    width: 1.09rem;
    height: 0.25rem;
    background: url(${require('../../assets/images/icon_tab_arc.png').default}) no-repeat;
    background-size: contain;
    display: none;
  }
`;

const Card = styled.section`
  font-size: 0.88rem;
  background-color: white;
  width: 21.56rem;
  box-shadow: 0rem 0.13rem 0.63rem 0rem rgba(54, 54, 54, 0.2);
  border-radius: 0.31rem;
  margin: 0 auto;
  padding: 1rem;
  box-sizing: border-box;
  text-align: justify;
  header {
    margin-bottom: 1rem;
  }
  footer {
    margin-top: 1.5rem;
  }
  span {
    color: #999999;
  }
`;
const Title = styled.h2`
  font-size: 1.19rem;
  line-height: 1;
  color: #333333;
  border-left: #006fd6 solid 0.2rem;
  padding-left: 0.5rem;
  font-weight: 500;
`;
const Description = styled.section`
  margin: 1.5rem 0 1rem;
  padding: 0 1rem;
  p {
    margin-top: 0.8rem;
    font-size: 0.94rem;
    line-height: 1.31rem;
    color: #666666;
    text-align: justify;

    /* overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical; */
  }
`;
const List = styled.section`
  & a > .item {
    border-top: solid #f2f2f2 0.5rem;
    padding: 1.5rem 1rem 0;
    img {
      width: 21.56rem;
      height: 5.62rem;
      display: block;
      margin-top: 1rem;
      border-radius: 0.19rem;
      overflow: hidden;
    }
    .container {
      display: flex;
      padding: 0.8rem 0;
      .item {
        flex: 1;
        text-align: center;
        .value {
          font-size: 1rem;
          line-height: 1.72rem;
          color: #333333;
        }
        .label {
          font-size: 0.88rem;
          line-height: 1.72rem;
          color: #666666;
        }

        position: relative;
        &:first-child::after {
          content: '';
          width: 0.06rem;
          height: 1.25rem;
          background-color: #ebebeb;
          position: absolute;
          top: 50%;
          right: 0;
          transform: translate3d(0, -50%, 0);
        }
      }
    }
  }
`;
const TabContentWrapper = styled.div`
  background-image: linear-gradient(to bottom, #006edd 3rem, white 3rem 100%);
`;
const Divider = styled.div`
  background-color: #f2f2f2;
  width: 100%;
  height: 0.5rem;
`;

function TabContent(props) {
  return (
    <TabContentWrapper>
      <Card>
        <header>
          <p>
            <span>{props.name}</span> &nbsp; {props.gender == 1 ? '男' : '女'} &nbsp; {props.birth}
          </p>
        </header>
        <section>
          <p>
            健康情况：
            <span>{props.health}</span>
          </p>
        </section>
        <footer>
          <p>
            已有保险：<span>{props.insured}</span>
          </p>
        </footer>
      </Card>
      <Description>
        <Title>保险方案</Title>
        <p>{props.content}</p>
      </Description>
      <List>
        {props.planRiskLs.map((item, index) => (
          <Link to={`/detail?id=${item.id}`} key={index}>
            <section className="item">
              <Title>{item.dictionaryContent.content}</Title>
              <img
                src={require(`../../assets/images/${item.dictionaryContent.icon}.jpg`).default}
                alt="pic"
              />
              <div className="container">
                <div className="item">
                  <p className="value">{item.totalAmount}万元</p>
                  <p className="label">建议保额</p>
                </div>
                <div className="item">
                  <p className="value">{item.totalPremiums}元/年</p>
                  <p className="label">保险费用</p>
                </div>
              </div>
            </section>
          </Link>
        ))}
      </List>
    </TabContentWrapper>
  );
}

function Plan() {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  let [id, setID] = useState(query.get('id'));
  let [list, setList] = useState([]);
  let [header, setHeader] = useState({});
  const [tabIndex, setTabIndex] = useState(0);

  // window.addEventListener(
  //   'message',
  //   (event) => {
  //     let payload = JSON.parse(event.data);
  //     if (payload.id) {
  //       setID(payload.id);
  //       http.get(`/baohuXcxCustomize/getCustomizePlan?id=${payload.id}`).then((res) => {
  //         setList(res.data.planConfigLs);
  //         setHeader({
  //           title: res.data.title,
  //           price: res.data.totalPremiums,
  //         });
  //       });
  //     }
  //   },
  //   false
  // );

  useState(() => {
    if (id) {
      http.get(`/baohuXcxCustomize/getCustomizePlan?id=${id}`).then((res) => {
        setList(res.data.planConfigLs);
        setHeader({
          title: res.data.title,
          price: res.data.totalPremiums,
        });
      });
    }
  }, [id]);

  if (!id) {
    return (
      <Page>
        <div
          style={{
            color: 'white',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
          }}
        >
          请提供方案ID
        </div>
      </Page>
    );
  }

  return (
    <Page>
      <Header>
        <h3>{header.title}</h3>
        <p>全部费用：{header.price}元</p>
      </Header>
      {/* 因为tab是异加载, 所以需要手动实现切换操作 */}
      <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
        <MTabList>
          {list.map((item, index) => (
            <MTab key={index}>{item.name}</MTab>
          ))}
        </MTabList>
        {list.map((item, index) => (
          <TabPanel key={index}>
            <TabContent {...item}></TabContent>
          </TabPanel>
        ))}
      </Tabs>
    </Page>
  );
}
export default Plan;
